import { TRequestPODetailsSampleDownload } from '@monorepo/types';

export const EXCEL_CONTEXT = {
  PRODUCED_QTY: 'PRODUCED_QTY',
  ORDERS_UPLOAD: 'ORDERS_UPLOAD',
  MACHINE_AVAILABILITY: 'MACHINE_AVAILABILITY',
  OPERATION_BREAKDOWN: 'OPERATION_BREAKDOWN',
  MATERIAL_INHOUSE: 'MATERIAL_INHOUSE',
} as const;

export type TExcelManagementInfo =
  | {
      excelContext: typeof EXCEL_CONTEXT.PRODUCED_QTY;
      downloadPayload: TRequestPODetailsSampleDownload;
      orderId: string;
      hasExcelErrorTemplate: boolean;
    }
  | {
      excelContext: typeof EXCEL_CONTEXT.ORDERS_UPLOAD | typeof EXCEL_CONTEXT.MATERIAL_INHOUSE;
      downloadPayload?: undefined;
      hasExcelErrorTemplate: boolean;
    }
  | {
      excelContext: typeof EXCEL_CONTEXT.MACHINE_AVAILABILITY;
      downloadPayload?: undefined;
      factoryId: string;
      hasExcelErrorTemplate: boolean;
    }
  | {
      excelContext: typeof EXCEL_CONTEXT.OPERATION_BREAKDOWN;
      downloadPayload?: undefined;
      otlId: string;
      productType: string;
      hasExcelErrorTemplate: boolean;
    };

export type TExcelManagementContext = (typeof EXCEL_CONTEXT)[keyof typeof EXCEL_CONTEXT];
